export default __webpack_public_path__ + "static/media/wasp.6b61a79c.png";